import React from 'react';
import * as styles from './style.module.scss';
import NavCta from '../NavCta';

const { burger, burgerWrap, burgerBar, burgerGreen, hasNavVisible } = styles;

export const BurgerButton = ({ greenButton, onClick, isNavOpened, withMobileCta=false }) => (
  <div className={burgerWrap}>
    {!greenButton && withMobileCta && <NavCta greenButton={greenButton} />}
    <button
      className={`${burger} ${greenButton ? burgerGreen : ''} ${
        isNavOpened ? hasNavVisible : ''
      }`}
      aria-label="Menu"
      onClick={onClick}
    >
      <span className={burgerBar}></span>
    </button>
  </div>
);
